import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import './Input.css';

export interface InputProps extends Omit<TextFieldProps, 'variant' | 'onChange' | 'onFocus'> {
  /**
   * Callback fired when the value changes
   * Receives the new value directly instead of the event
   */
  onValueChange?: (value: string) => void;
  
  /**
   * Standard onChange handler (receives the event)
   */
  onChange?: React.ChangeEventHandler<HTMLInputElement>;

  /**
   * Standard onFocus handler (receives the event)
   */
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
}

const Input: React.FC<InputProps> = ({
  className = '',
  onValueChange,
  onChange,
  onFocus,
  ...otherProps
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onValueChange) {
      onValueChange(e.target.value);
    }
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <TextField
      variant="outlined"
      className={`input ${className}`}
      onChange={handleChange}
      onFocus={onFocus}
      {...otherProps}
    />
  );
};

export default Input;
